var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParadoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.58,
    height: 30.58,
    rx: 6.75,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5258 6.41406C10.0756 6.41406 9.64397 6.59287 9.32569 6.91114C9.00742 7.22942 8.82861 7.6611 8.82861 8.11121V21.6883C8.82861 22.1385 9.00742 22.5701 9.32569 22.8884C9.64397 23.2067 10.0756 23.3855 10.5258 23.3855H21.2743C21.7244 23.3855 22.1561 23.2067 22.4744 22.8884C22.7927 22.5701 22.9715 22.1385 22.9715 21.6883V13.1871C22.9715 12.6716 22.7664 12.1773 22.4022 11.8124L17.501 6.91118C17.1828 6.5929 16.7511 6.41408 16.301 6.41406H10.5258ZM9.88933 8.11121C9.88933 7.94241 9.95638 7.78054 10.0757 7.66118C10.1951 7.54183 10.357 7.47478 10.5258 7.47478H15.9V12.0712C15.9 12.4463 16.049 12.806 16.3143 13.0713C16.5795 13.3365 16.9392 13.4855 17.3143 13.4855H21.9108V21.6883C21.9108 21.8571 21.8437 22.019 21.7244 22.1384C21.605 22.2577 21.4431 22.3248 21.2743 22.3248H10.5258C10.357 22.3248 10.1951 22.2577 10.0757 22.1384C9.95638 22.019 9.88933 21.8571 9.88933 21.6883V8.11121ZM21.5148 12.4248H17.3143C17.2206 12.4248 17.1306 12.3875 17.0643 12.3212C16.998 12.2549 16.9608 12.165 16.9608 12.0712V7.87078L21.5148 12.4248Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParadoc);
export default __webpack_public_path__ + "static/media/paradoc.b14a7ecf06c8a46adf8f0c80db95030c.svg";
export { ForwardRef as ReactComponent };